import { render, staticRenderFns } from "./HEX.vue?vue&type=template&id=c2004726&scoped=true&"
import script from "./HEX.vue?vue&type=script&lang=js&"
export * from "./HEX.vue?vue&type=script&lang=js&"
import style0 from "./HEX.vue?vue&type=style&index=0&id=c2004726&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2004726",
  null
  
)

export default component.exports